module.exports = __webpack_public_path__ + "static/bride-flowers-e01f42ef6e999042b107ed3fbbea2e71.svg";